<template>
  <div>
    <b-row class="mb-4 header">
        <b-col cols="12">
          <img src="../assets/images/caterer.svg" alt="caterer" class="logo" /> <h2 class="pt-2 my-4 ">Caterer</h2>
          <b-btn @click="signOut" class="signout-btn">Sign Out</b-btn>
        </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
  name: 'customHeader',
  props: [
    'orderDetails'
  ],
  computed: {
  },
  methods: {
    signOut() {
      this.$router.push( { name: 'cateringSignOut' });
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  .logo {
    color: #FFAF10;
    max-height: 50px;
    vertical-align: bottom;
    margin-right: 10px;
    font-size: 50px;
  }
  h2 {
    color: #FFAF10;
    display: inline;
  }
  .signout-btn {
    position: absolute;
    right: 20px;
    outline: none;
    background: transparent;
    color: #000;
    border: none;
    top: 10px;
  }
}

</style>